@if (auftrag; as auftrag) {
  <div
    class="soft-card rounded-md hover:bg-hover soft-card !p-0 overflow-clip cursor-pointer flex mt-2"
  >
    <div class="bg-accent min-w-2">&nbsp;</div>
    <div class="flex flex-col justify-center flex-nowrap text-content truncate p-2">
      <span class="text-sm mb-0 text-accent font-bold uppercase"
        >Auftrag {{ auftrag.number }}</span
      >
      <p class="block text-base font-semibold truncate mb-0">{{ auftrag.object.name }}</p>
      <p class="text-sm truncate mb-[3px]">
        @if (auftrag?.customer?.name1) {
          {{ auftrag?.customer?.number }} - {{ auftrag?.customer?.name1 }}
        }
        @if (auftrag?.customer?.name2) {
          {{ auftrag?.customer?.name2 }}
        }
        @if (
          auftrag?.customer?.kurzbez &&
          !auftrag?.customer?.name1 &&
          !auftrag.customer?.name2
        ) {
          {{ auftrag?.customer?.number }} - {{ auftrag?.customer?.kurzbez }}
        }
      </p>
      @if (
        auftrag?.customer?.strasse || auftrag?.customer?.plz || auftrag?.customer?.ort
      ) {
        <p class="body-list text-sm color-light truncate mt-0">
          {{
            (auftrag?.customer?.strasse ? auftrag?.customer?.strasse + ', ' : '') +
              auftrag?.customer?.plz +
              ' ' +
              auftrag?.customer?.ort
          }}
        </p>
      }
    </div>
    <div class="items-center h-full py-10 px-4 flex content-center justify-center">
      <i class="fa-regular fa-chevron-right text-gray"></i>
    </div>
  </div>
}
